export default "__VITE_ASSET__DnV6flrO__"